import React from 'react'
import UserCard from './UserCard.jsx'

const Richie = () =>
  <UserCard
    name="Richie"
    title="Managing Director"
    dyk="Richie has a T-Rex in his kitchen (ask him and he'll prove it to you!). He also has an alarming number of Pokemon cards."
  >
    <p>
      Richie likes to keep life as simple as possible, which is etched into
      the design of our website. He also doesn't like to believe that
      everything at LFH is his responsibility! Richie is a man of simple
      pleasures and enjoys mowing (perfectly straight) stripes into his lawn
      whilst enjoying a nice cold beer. Oh, and watching the F1! He's a child
      at heart and spends most of his spare time with wife Grace and son
      Archie. He also enjoys badminton, karting, fossil hunting, scuba diving
      and cycling.
    </p>
  </UserCard>


export default Richie